import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-148907FSQF';

const loadScript = () => {
  if (!measurementId || document.getElementById('google-analytics-script')) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.id = 'google-analytics-script';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });
};

const trackPageView = (path) => {
  if (!measurementId || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    send_to: measurementId
  });
};

export default function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    loadScript();
  }, []);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
